export default __webpack_public_path__ + "static/media/photo--lg--misc-6.3841f324.jpg";